var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("circle",{"cx":"25","cy":"25","fillOpacity":".1","r":"25","key":0}),React.createElement("path",{"d":"m25.7071 33.707 7-7c.3905-.3905.3905-1.0235 0-1.414s-1.0235-.3905-1.414 0l-5.293 5.293v-13.586c0-.552-.448-1-1-1s-1 .448-1 1v13.586l-5.293-5.293c-.3905-.3905-1.0235-.3905-1.414 0-.1955.1955-.293.451-.293.707s.0975.5115.293.707l7 7c.3905.3905 1.0235.3905 1.414 0z","key":1})]));
}

ArrowDown.defaultProps = {"fill":"none","height":"50","viewBox":"0 0 50 50","width":"50"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
